module.exports = __webpack_public_path__ + "static/media/img_leftpanel.855e06ba.jpg";